import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NVD3Chart from 'react-nvd3';
import moment from 'moment';

import * as colors from '../utils/Theme';

var context = {
  formatXAxis: (d) => {
    // return d3.time.format('%x')(new Date(d));
    return moment(d).format('DD/MM');
  },
  formatYAxis: (d) => {
    return (d);
  },
};


class AvgBarChartComponent extends Component {

  constructor() {
    super();
    this.formatDataForChart = this.formatDataForChart.bind(this);
  }

  formatDataForChart(data) {
    const res = [
      {
        key: this.props.labels[0],
        values : [],
        color: colors.rating1,
      },
      {
        key: this.props.labels[1],
        values : [],
        color: colors.rating2,
      },
      {
        key: this.props.labels[2],
        values : [],
        color: colors.rating3,
      },
    ];

    for (let i = 0; i < data.length; i += 1) {
      const timeRangeElement = data[i];
      res[0].values.push([timeRangeElement.date, timeRangeElement.rating1]);
      res[1].values.push([timeRangeElement.date, timeRangeElement.rating2]);
      res[2].values.push([timeRangeElement.date, timeRangeElement.rating3]);

    }
    return res;
  };

  render() {
    if (this.props.data) {
      return (
        <div>
          <NVD3Chart
            id="barChart"
            type={'multiBarChart'}
            datum={this.formatDataForChart(this.props.data)}
            context={context}
            xAxis={{
                tickFormat: {
                name:'formatXAxis',
                type:'function',
                }
            }}
            yAxis={{
                tickFormat: {
                name:'formatYAxis',
                type:'function',
                }
            }}
            margin={this.props.horizontal ? {left: 100} : {right:0}}
            showControls={true}
            x={(d) => {
              const date = moment(d[0]);
              return date.valueOf();
            }}
            y={(d) => (d[1])}
            height={this.props.horizontal ? 850 : 250}
            stacked={this.props.stacked}
          />
        </div>
      );
    }
    return;
  }
}

AvgBarChartComponent.propTypes = {
  horizontal: PropTypes.bool,
  data: PropTypes.array.isRequired,
  labels: PropTypes.array.isRequired,
  stacked: PropTypes.bool,
};


export default AvgBarChartComponent;



// WEBPACK FOOTER //
// ./src/components/AvgBarChartComponent.js